import Moment from "moment";
import DateSelection from "./date-selection";

export default class DateDaySelection extends DateSelection {

    constructor(withSunday) {
        super();
        this.dateStep = 'day';
        this.withSunday = (withSunday != null ? withSunday : false);
    }

    isEnabled(date) {
        return Moment(date).isoWeekday() == 7 ? this.withSunday : true;
    }

    startOfRange(date) {
        return Moment(date).startOf('week')
    }

    endOfRange(date) {
        return Moment(date).endOf('week');
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/week-date-selection/date-day-selection.js